import { Box } from '@mui/material';

import CallCenterDashboardContainer from '../CallCenter/CallCenterRouterContainer';

import FooterComponent from './FooterComponent';

import Route from '../../routes/SentryRoute';
import ErrorBoundary from './ErrorBoundary';

const MainCallCenterComponent = () => (
  <ErrorBoundary>
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100vh',
      }}
    >
      <Box sx={{ flexGrow: 1, justifyContent: 'center' }}>
        <Route path="/" component={CallCenterDashboardContainer} />
      </Box>
      <FooterComponent />
    </Box>
  </ErrorBoundary>
);

export default MainCallCenterComponent;
